//Redux Action Types
export const ActionTypes = {
  OPEN_STICKY_ADD_TO_CART: "OPEN_STICKY_ADD_TO_CART",
  CLOSE_STICKY_ADD_TO_CART: "CLOSE_STICKY_ADD_TO_CART",
  ADD_TO_CART: "ADD_TO_CART",
  OPEN_MINI_CART: "OPEN_MINI_CART",
  OPEN_ACCOUNT_SIDEBAR: "OPEN_ACCOUNT_SIDEBAR",
  IS_OPENING_ACCOUNT_SIDEBAR : "IS_OPENING_ACCOUNT_SIDEBAR",
  OPEN_ACCOUNT_SIDEBAR_PWA_HEADER : "OPEN_ACCOUNT_SIDEBAR_PWA_HEADER",
  OPEN_WISHLIST_SIDEBAR: "OPEN_WISHLIST_SIDEBAR",
  OPEN_ENGRAVE_SIDEBAR: "OPEN_ENGRAVE_SIDEBAR",
  LOGGEDIN_USER: "LOGGEDIN_USER",
  LOWER_HEADER_Z_INDEX: "LOWER_HEADER_Z_INDEX",
  IS_HEADER_SCROLL:"IS_HEADER_SCROLL",
  IS_SUBMENU_VISIBLE: "IS_SUBMENU_VISIBLE",
  IS_MENU_VISIBLE: "IS_MENU_VISIBLE",
  IS_SUPERBRAND_HERO_PRESENT: "IS_SUPERBRAND_HERO_PRESENT",
  SELECTED_FILTERS: "SELECTED_FILTERS",
  USER_ORDER: "USER_ORDER",
  INITIALIZE_WISHLIST: "INITIALIZE_WISHLIST",
  INITIALIZE_CAUSE_DATA: "INITIALIZE_CAUSE_DATA",
  DEFAULT_CAUSE: "DEFAULT_CAUSE",
  USER_CAUSE: "USER_CAUSE",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
  FAVOURITE_ICON_ANIMATION_END: "FAVOURITE_ICON_ANIMATION_END",
  SIDEBAR_CAUSE: "SIDEBAR_CAUSE",
  OPEN_CHARITYCHANGE_POPUP: "OPEN_CHARITYCHANGE_POPUP",
  SET_WISHLIST_LOADING_STATE: "SET_WISHLIST_LOADING_STATE",
  NB_HITS_COUNT_DATA: "NB_HITS_COUNT_DATA",
  NOSTO_PLACEMENTS: "NOSTO_PLACEMENTS",
  MENU_DATA: "MENU_DATA",
  OPEN_ACCOUNT_SIDEBAR_WITH_MSG: "OPEN_ACCOUNT_SIDEBAR_WITH_MSG",
  OPEN_QB_MINI_CART:"OPEN_QB_MINI_CART",
  UPDATE_CART: "UPDATE_CART",
  GLOBAL_ACTIVE_TAB: "GLOBAL_ACTIVE_TAB",
  PLP_WISHLIST_CLICKED:"PLP_WISHLIST_CLICKED",
  UPDATE_AUTH:"UPDATE_AUTH",
  PRICE_FILTER:"PRICE_FILTER",
  SIGNIN_DRAWER:"SIGNIN_DRAWER",
  SET_SCROLL_POS:"SET_SCROLL_POS",
  SHOW_CHARITY_ACTIVE_MESSAGE:"SHOW_CHARITY_ACTIVE_MESSAGE",
  IS_PWA: "IS_PWA",
  IS_GUEST: "IS_GUEST",
  IS_VISITED: "IS_VISITED",
  SET_SEARCH_ICON: "SET_SEARCH_ICON",
  WELCOME_STEP: "WELCOME_STEP",
  IS_PWA_SUBMENU_VISIBLE:"IS_PWA_SUBMENU_VISIBLE",
  IS_PWA_SHOW_SHOP_MENU: "IS_PWA_SHOW_SHOP_MENU",
  WELCOME_JOURNEY: "WELCOME_JOURNEY",
  PREVIOUS_NAV: "PREVIOUS_NAV",
  PWA_LOADER: "PWA_LOADER",
  PWA_LINK_TAG_CLICK: "PWA_LINK_TAG_CLICK",
  OPEN_HELP_SIDEBAR: "OPEN_HELP_SIDEBAR",
  CLOSE_REACT_SIDEBAR: "CLOSE_REACT_SIDEBAR",
  WISHLIST_NOT_INITIALISED: "WISHLIST_NOT_INITIALISED",
  OPEN_FORGOT_SIDEBAR: "OPEN_FORGOT_SIDEBAR",
  SET_OLI_CATEGORY: "SET_OLI_CATEGORY",
  OPEN_OLI_POPUP: "OPEN_OLI_POPUP",
  CLOSE_OLI_POPUP: "CLOSE_OLI_POPUP",
  DISPLAY_FEEDBACK_POPUP: "DISPLAY_FEEDBACK_POPUP"
};
